import { type MRT_ColumnDef } from 'mantine-react-table';
import moment from 'moment';
import React, { useMemo } from 'react';
import { CustomChip } from '../../../../../layout/styledcomponents/CustomChip';
import GenericTable from '../../../../shared/GenericTable';
import { trackEvent } from '../../../../../app/Analytics';

export default function TopGuestsListReport(params: any) {
    const processedData = useMemo(() => {
        if (!params.data) return [];
        return params.data.map((row: any) => ({
            ...row,
            createdDate: new Date(
                new Date(row.createdDate).setHours(0, 0, 0, 0),
            ),
        }));
    }, [params.data]);

    const columns: MRT_ColumnDef<any>[] = [
        {
            accessorKey: 'name',
            header: 'Guest Company',
            mantineTableHeadCellProps: {
                title: 'Companies who have completed the most reservations',
            },
        },

        {
            accessorKey: 'createdDate',
            header: 'Member Since',
            filterVariant: 'date',
            filterFn: 'equals',
            sortingFn: 'datetime',
            mantineTableHeadCellProps: {
                title: 'Member of 7DAY since date',
            },
            mantineFilterDateInputProps: {
                valueFormat: 'DD/MM/YYYY',
            },
            Cell: ({ row, cell }) =>
                moment(row.original?.createdDate).format('DD/MM/YYYY'),
        },

        {
            accessorKey: 'isActive',
            id: 'isActive',
            header: 'Status',
            filterVariant: 'select',
            filterFn: (row, _columnId, filterValue) => {
                if (filterValue === '') return true;
                return String(row.getValue('isActive')) === filterValue;
            },

            mantineFilterSelectProps: {
                data: [
                    { label: 'Enabled', value: 'true' },
                    { label: 'Disabled', value: 'false' },
                ],
                clearable: true,
            },
            mantineTableHeadCellProps: {
                title: 'Company Membership Status',
            },
            Cell: ({ row, cell }) => {
                const status = cell.getValue();

                return (
                    <CustomChip
                        label={status === true ? 'Enabled' : 'Disabled'}
                        color={status === true ? 'green' : 'red'}
                        variant='outlined'
                    />
                );
            },
        },
        {
            accessorKey: 'activeUsers',
            header: 'Current Users',
            mantineTableHeadCellProps: {
                title: 'No. of current users on 7DAY belonging to company',
            },
        },
        {
            accessorKey: 'completedBookings',
            header: 'Completed Reservations',
            mantineTableHeadCellProps: {
                title: 'No. of successfully completed reservations during date range',
            },
        },
    ];

    return (
        <GenericTable
            columns={columns}
            data={processedData}
            tableName='7DAY-Top-Guests-Report'
            loading={!params.data}
            onRowClick={() => {
                trackEvent(
                    'Reports',
                    'Top Guests Report Clicked',
                    'Top Guests Report Clicked',
                );
            }}
        />
    );
}
